import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export interface ApprovalStatus {
  hasProfile: boolean;
  isApproved: boolean;
  loading: boolean;
}

export function useApprovalStatus(): ApprovalStatus {
  const { user, loading: authLoading } = useAuth();
  const [approvalStatus, setApprovalStatus] = useState<ApprovalStatus>({
    hasProfile: false,
    isApproved: false,
    loading: true
  });

  useEffect(() => {
    async function checkApprovalStatus() {
      if (authLoading) return;
      
      if (!user) {
        setApprovalStatus({ hasProfile: false, isApproved: false, loading: false });
        return;
      }

      try {
        const { data: profile } = await supabase
          .from('profiles')
          .select('registration_approved')
          .eq('user_id', user.id)
          .maybeSingle();

        if (!profile) {
          setApprovalStatus({ hasProfile: false, isApproved: false, loading: false });
        } else {
          setApprovalStatus({
            hasProfile: true,
            isApproved: profile.registration_approved || false,
            loading: false
          });
        }
      } catch (error) {
        console.error('Error checking approval status:', error);
        setApprovalStatus({ hasProfile: false, isApproved: false, loading: false });
      }
    }

    checkApprovalStatus();
  }, [user, authLoading]);

  return approvalStatus;
}